import { useEffect, useState } from 'react'

/**
 * Reads the current numeric `--p` value from a section element by id.
 * Only use this when React state is genuinely needed (e.g. odometer text
 * counting). For pure visual transforms, prefer CSS calc(var(--p) * ...)
 * directly — no hook required.
 */
export function useScrollProgressValue(id) {
    const [p, setP] = useState(0)
    useEffect(() => {
        let rafId
        let lastVal = 0
        function tick() {
            const el = document.getElementById(id)
            if (el) {
                const val = parseFloat(el.style.getPropertyValue('--p')) || 0
                if (val !== lastVal) {
                    lastVal = val
                    setP(val)
                }
            }
            rafId = requestAnimationFrame(tick)
        }
        rafId = requestAnimationFrame(tick)
        return () => cancelAnimationFrame(rafId)
    }, [id])
    return p
}
